import Axios from "../util/axiosInstance";

export const PostSaveJob = (payload) => {
  return Axios.post("/api/TalentJobCenter/AddSavedJob", payload)
 
};
